import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";
const API_BASE = getApiBaseUrl();

export const getAIReport = async (token: string): Promise<AIReport> => {
  return await apiFetch(`${API_BASE}/api/management/ai-reports`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export interface AIAdvice {
  strengths: string[];
  next_steps: string[];
  areas_for_improvement: string[];
}

export interface AIReport {
  ai_comment: string;
  ai_advice: AIAdvice;
  report_data: {
    labels: string[];
    data: number[];
  };
  created_at: string;
}
